import { apiConstants } from "../../../constants/apiConstants"
import { authConstants } from "../../../constants/authConstants"
import { notificationConstants } from "../../../constants/notificationConstants"
import { authService } from "../../../services/authService"

const initialState = {
    lastIdentifier: null,
    pendingDeepLink: null,
}

export default function notifications(state = initialState, action) {
    switch (action.type) {
        case notificationConstants.SET_LAST_IDENTIFIER:
            return {
                ...state,
                lastIdentifier: action.lastIdentifier,
            }

        case notificationConstants.CLEAR_LAST_IDENTIFIER:
            return {
                ...state,
                lastIdentifier: null,
            }

        case notificationConstants.SET_PENDING_DEEP_LINK:
            return {
                ...state,
                pendingDeepLink: action.url,
            }

        case notificationConstants.CLEAR_PENDING_DEEP_LINK:
            return {
                ...state,
                pendingDeepLink: null,
            }

        // Involuntary re-auth (token expired) — keep pendingDeepLink so the
        // user lands on their original target after logging back in. Only
        // user-specific transient state (lastIdentifier) is wiped.
        case authConstants.LOGOUT_401:
            return {
                ...state,
                lastIdentifier: null,
            }

        // Voluntary logout or explicit auth reset — wipe everything,
        // including any pending deep link (it belonged to the prior session).
        case authConstants.RESET_AUTH_STATE:
        case authService.logout.name + apiConstants._SUCCESS:
            return initialState

        default:
            return state
    }
}
